<template>
    <centered-card :headline="headline">

            <div class="mb-4">
                <input type="text" v-model="search" placeholder="filter blogs" class="form-control">
            </div>

            <loading-indicator name="user.getBlogs"/>

            <blog-item v-for="blog, k in selected" :key="k" :blog="blog"/>

            <button class="btn btn-block btn-primary" @click.prevent="createBlog()">Create a new Blog</button>
            <button class="btn btn-block btn-tumblr" @click.prevent="syncTumblr()">Sync Tumblr Blogs</button>

    </centered-card>
</template>

<script>

    import BlogItem from './UserBlogListItem.vue';
    import CenteredCard from '../../layout/CenteredCard.vue';
    import LoadingIndicator from "../../ui/LoadingIndicator";

    export default {
        name: '',
        data() {
            return {
                blogs: [],
                search: '',
                isActive: false
            }
        },
        computed:{
            selected(){
                return this.blogs.filter((blog) => blog.title.toLowerCase().indexOf(this.search)>=0 )
            },
            headline() {
              let str = 'My Blogs';
              const len = this.selected.length;
              if (len > 0) str += ` (${len})`;
              return str;
            }
        },
        mounted() {
          this.isActive = true;
          this.$bus.$on('blog-deleted', this.loadBlogs);
          this.$bus.$on('bloglist.exists', (data)=>{
            if(this.isActive) this.$bus.$emit('blog-modal.listExists', this.getNextPrevBlogs(data.currentBlog));
          });
          this.loadBlogs();
        },
        beforeDestroy() {
          this.isActive = false;
        },
        methods: {
            loadBlogs(){
                this.$api.getUserBlogs().then((res)=>{
                    this.blogs = res.data.blogs
                })
            },
            getNextPrevBlogs(current){
              let last = null;
              let next = null;
              for(let i in this.selected){
                const b = this.selected[i];
                if(b === current){
                  next = 1;
                  continue;
                }
                if(next === 1){
                  next = b;
                  break;
                }
                last = b;
              }
              if(next === 1) next = null;
              return {
                nextBlog: next,
                prevBlog: last
              }
            },
            createBlog(){
                this.$router.push({name:'CreateBlog'})
            },
            syncTumblr(){
                this.$router.push({name:'SyncTumblr'});
            }
        },
        components: {
          LoadingIndicator,
            BlogItem,
            CenteredCard
        }
    }
</script>

<style lang="sass">

</style>



// WEBPACK FOOTER //
// src/components/user/blogs/UserBlogList.vue